import type { FC } from 'react';

import {
  ApprovalDetailedStatusIcon as SharedApprovalDetailedStatusIcon,
  type ApprovalDetailedStatusIconProps as SharedApprovalDetailedStatusIconProps,
} from '@iconik-io/shared-lib/src/react/components/shared/approval_detailed_status_icon/approval_detailed_status_icon';
import type { StatusTooltipProps } from '@iconik-io/shared-lib/src/react/components/shared/approval_detailed_status_icon/statuses/status_tooltip';

import { useAppSelector } from '../../store/react_redux_typed';
import TooltipTrigger from '../tooltip_trigger/tooltip_trigger';

type ApprovalDetailedStatusIconProps = Omit<
  SharedApprovalDetailedStatusIconProps,
  'userId' | 'TooltipComponent'
>;

const StatusTooltip: FC<StatusTooltipProps> = ({ label, children }) => (
  <TooltipTrigger
    tooltipText={label}
    placement="bottom"
    componentProps={{
      role: 'status',
      'aria-label': label,
    }}
  >
    {children}
  </TooltipTrigger>
);

const ApprovalDetailedStatusIcon: FC<ApprovalDetailedStatusIconProps> = (
  props,
) => {
  const userId = useAppSelector((state) => state.authReducer.userData.id);
  return (
    <SharedApprovalDetailedStatusIcon
      {...props}
      userId={userId}
      TooltipComponent={StatusTooltip}
    />
  );
};

export default ApprovalDetailedStatusIcon;
